import styled, { css } from 'styled-components';
import { Button } from 'react-bootstrap';
import { LuSlidersHorizontal } from 'react-icons/lu';

import LayerCheckbox from './LayerCheckbox';
import InfoTooltip from '@components/infoTooltip/InfoTooltip';

const LayerSettings = ({
	id,
	label,
	onCheck,
	onUncheck,
	defaultState = true,
	layer = null,
	layerFunctions = [],
	layerExplanations = [],
	disabled,
}) => {
	return (
		<div className="layer-settings d-flex flex-row gap-3 align-items-center">
			<LayerCheckbox
				id={id}
				label={label}
				layer={layer}
				defaultChecked={defaultState}
				onCheck={onCheck}
				onUncheck={onUncheck}
				disabled={disabled}
			/>
			<div className="d-flex flex-row gap-2">
				{layerExplanations?.map((explanation, index) => (
					<LayerExplanation
						key={`le-${index}`}
						explanation={explanation}
					/>
				))}
				{layerFunctions?.map((func, index) => (
					<LayerFunction
						key={`lf-${index}`}
						{...func}
						disabled={disabled}
					/>
				))}
			</div>
		</div>
	);
};
export default LayerSettings;

const visibilityStyles = css`
	transition: all 0.2s ease-in-out;
	opacity: 0;

	.layer-settings > div:has(input:checked) ~ div & {
		opacity: 0.6;
		pointer-events: auto;
	}

	.layer-settings > div:has(input:checked) ~ div & {
		&:hover,
		&:focus,
		:where(li):hover > &,
		:where(div):hover > & {
			opacity: 1;
			pointer-events: auto;
		}
	}

	.layer-settings > div:has(input:not(:checked)) ~ div & {
		&:hover,
		&:focus,
		:where(li):hover > &,
		:where(div):hover > & {
			opacity: 0.3;
			pointer-events: none;
		}
	}
`;

const LayerFunctionButton = styled(Button)`
	${visibilityStyles}
`;
const LayerFunction = ({
	icon = <LuSlidersHorizontal />,
	title,
	onClick,
	disabled,
}) => {
	return (
		<LayerFunctionButton
			variant="dark"
			className="p-0"
			onClick={onClick}
			disabled={disabled}>
			<InfoTooltip
				tooltipContainerId="tooltip-sidebar-root"
				placement="top"
				data-tooltip-offset={20}
				content={title}
				showIcon={false}>
				<span className="d-flex align-items-center p-1">{icon}</span>
			</InfoTooltip>
		</LayerFunctionButton>
	);
};

const ExplanationWrapper = styled.div`
	${visibilityStyles}
`;

const LayerExplanation = ({ explanation }) => {
	return <ExplanationWrapper>{explanation}</ExplanationWrapper>;
};
